module.exports = __webpack_public_path__ + "media/images/logos/04-d8faf6f996e5dd279695129b5c66eebc.png";